// src/pages/buyers/utils.js

export const formatCurrency = (amount) => {
  return `₦${Number(amount).toLocaleString()}`;
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};